import { Button as AIMEButton } from "tot-loft-component-library";
import styled from "@emotion/styled";
import React from "react";

export default function PaymentSuceessModal({ onClose, payoutData }) {
  return (
    <RootWrapperJkn>
      <Overlay>
        <Wrapper>
          <PopupMessages>
            <Left>
              <Frame1391>
                <OwlBaloon />
                <AccountCreatedSuccessfully>
                  Payout request submitted
                </AccountCreatedSuccessfully>
                <CongratulationsYourAccountHasBeenCreatedPleaseSignInWithYourCredentialsToGetStarted>
                  Your payout request for £{payoutData?.amount} has been
                  received.
                  <br />
                  It will now be processed - please allow 3–5 business days for
                  the payment to arrive. <br />
                  If you have any questions, feel free to contact us at
                  support@paartner.com
                </CongratulationsYourAccountHasBeenCreatedPleaseSignInWithYourCredentialsToGetStarted>
                <Frame1400>
                  <AIMEButton
                    size="small"
                    onClick={onClose}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "row",
                      alignItems: "center",
                      flex: "none",
                      borderRadius: "999px",
                      width: "251px",
                      background: "rgb(33, 37, 67)",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "center",
                      boxSizing: "border-box",
                      padding: "16px 32px",
                      "&:hover": {
                        background: "rgb(33, 37, 67)",
                        opacity: "0.9",
                      },
                    }}
                  >
                    <span
                      style={{
                        color: "white",
                        textOverflow: "ellipsis",
                        fontSize: "16px",
                        fontFamily: "Montserrat, sans-serif",
                        fontWeight: "600",
                        lineHeight: "110%",
                        textAlign: "left",
                      }}
                    >
                      Go to Rewards
                    </span>
                  </AIMEButton>
                </Frame1400>
              </Frame1391>
            </Left>
          </PopupMessages>
        </Wrapper>
      </Overlay>
    </RootWrapperJkn>
  );
}

const RootWrapperJkn = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
`;

const Overlay = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  gap: 8px;
  background: linear-gradient(-90deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  border-radius: 32px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 40px 24px 24px;
`;

const Frame1392 = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  height: 1px;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const IconFilled = styled.img`
  width: 32px;
  height: 32px;
  object-fit: cover;
`;

const PopupMessages = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  width: 912px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Left = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 8px;
  width: 912px;
  box-sizing: border-box;
  padding: 24px 0px;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Frame1391 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const OwlBaloon = styled.div`
  width: 174px;
  height: 174px;
  background: url("https://d3nakrlcog1u3z.cloudfront.net/1749639770005-a06d899665d6a513473f45dcc128673b52102e9a.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`;

const AccountCreatedSuccessfully = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 24px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const CongratulationsYourAccountHasBeenCreatedPleaseSignInWithYourCredentialsToGetStarted = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1400 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 16px;
  box-sizing: border-box;
`;

const ButtonsApp = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  flex: none;
  border-radius: 999px;
  width: 251px;
  background: rgb(33, 37, 67);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px 32px;
`;

const ButtonLabel = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  line-height: 110%;
  text-align: left;
`;
